import Services from '../services';

export default {
  name: 'inventory_count',
  mixins: [Services],
  data() {
    return {
      statusses: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Pending',
          value: 'pending'
        },
        {
          name: 'In progress',
          value: 'in_progress'
        },
        {
          name: 'Completed',
          value: 'completed'
        }
      ],
      status: {
        name: 'All',
        value: ''
      },
      inventory_count_edit_index: -1,
      inventory_counts: [],
      inventory_count: {
        items: []
      },
      inventory_counts_page: 1,
      inventory_counts_total: 0,
      data_loading: false
    }
  },
  methods: {
    async update_inventory_counts() {
      this.data_loading = true
      var inventory_counts = this.$communicator.then(this, await this.$communicator('inventory_counts', {
        arguments: [10, this.inventory_counts_page],
        params: {
          service: this.store?._id,
          status: this.status.value,
          search: this.search
        }
      }))
      if (inventory_counts) {
        for (let i = 0;i < inventory_counts.data.length;i++) {
          inventory_counts.data[i].status = this.$t(inventory_counts.data[i].status)
          var time = new Date(inventory_counts.data[i].created_time)
          inventory_counts.data[i].created_time = time.getDate() + '/' + (time.getMonth() + 1) + '/' + time.getFullYear()
        }
        this.inventory_counts = inventory_counts.data
        this.inventory_counts_total = inventory_counts.page
      }
      this.data_loading = false
    }
  },
  mounted() {
    this.statusses = [
      {
        name: this.$t('all'),
        value: ''
      },
      {
        name: this.$t('pending'),
        value: 'pending'
      },
      {
        name: this.$t('in_progress'),
        value: 'in_progress'
      },
      {
        name: this.$t('completed'),
        value: 'completed'
      }
    ]
    this.status = {
      name: this.$t('all'),
      value: ''
    }
    this.update_inventory_counts()
  }
}